import { track } from "./trackEvent";

export type CompositeRenderFailedReason = "zero_dimensions" | "cors_taint" | "draw_threw";

export const trackCompositeRenderFailed = (params: {
  reason: CompositeRenderFailedReason;
  site: string;
  sourceWidth?: number;
  sourceHeight?: number;
  errorMessage?: string;
}) => {
  track("design_lab_composite_render_failed", {
    reason: params.reason,
    site: params.site,
    source_width: params.sourceWidth ?? null,
    source_height: params.sourceHeight ?? null,
    error_message: params.errorMessage ?? null,
    timestamp: Date.now()
  });
};
